import React, { useState, useEffect, useRef } from 'react';
import Flag from 'react-world-flags';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import config from '../config';

const LanguageSwitcher = ({ onLangChange }) => {
  const [selectedLang, setSelectedLang] = useState(localStorage.getItem('language') || config.languages.default);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const getFlagCode = (lang) => (lang === "en" ? "gb" : lang);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Aggiorna il meta tag quando il componente si monta
    const currentLang = localStorage.getItem('language') || config.languages.default;
    const metaLang = document.querySelector('meta[http-equiv="Content-Language"]');
    if (metaLang) {
      metaLang.content = currentLang;
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleLangChange = (lang) => {
    if (lang === selectedLang) {
      setIsOpen(false);
      return;
    }

    // Salva la lingua nel localStorage
    localStorage.setItem('language', lang);

    // Aggiorna lo state locale
    setSelectedLang(lang);
    setIsOpen(false);

    // Chiama il callback se fornito
    if (onLangChange) {
      onLangChange(lang);
    }

    // Imposta un handler per dopo il reload
    window.onload = () => {
      const metaLang = document.querySelector('meta[http-equiv="Content-Language"]');
      if (metaLang) {
        metaLang.content = lang;
      }
    };

    // Forza il reload della pagina
    window.location.replace(window.location.href);
  };

  // Nascondi il componente se c'è solo una lingua
  if (Object.keys(config.languages.available).length < 2) {
    return null;
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <html lang={selectedLang} />
        </Helmet>
      </HelmetProvider>
      <div ref={dropdownRef} className="language-switcher" style={{ position: 'relative' }}>
        <button
          onClick={toggleDropdown}
          className="btn"
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '40px',
            height: '40px',
            fontSize: '14px',
            border: 'none'
          }}
          aria-label={`Selected language: ${config.languages.available[selectedLang]}`}
        >
          <Flag code={getFlagCode(selectedLang)} style={{ width: 25, height: 25, borderRadius: 16 }} />
        </button>

        {isOpen && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              right: '0.3rem',
              marginTop: '4px',
              background: 'white',
              border: '1px solid #dee2e6',
              borderRadius: '15px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              zIndex: 1000,
              width: '120px',
              overflow: 'hidden'
            }}
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="language-menu"
          >
            {Object.keys(config.languages.available).map((lang) => (
              <button
                key={lang}
                onClick={() => handleLangChange(lang)}
                className="dropdown-item"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  padding: '10px 16px',
                  border: 'none',
                  background: selectedLang === lang ? '#f8f9fa' : 'white',
                  cursor: 'pointer',
                  textAlign: 'left',
                  fontSize: '14px'
                }}
                role="menuitem"
              >
                <Flag code={getFlagCode(lang)} style={{ width: 20, height: 15, marginRight: "8px" }} />
                {config.languages.available[lang]}
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default LanguageSwitcher;